<template>
    <div id="app">
        <iu-container>
            <iu-header>
                <iu-nav />
            </iu-header>
            <iu-main class="main">
                <router-view />
            </iu-main>
        </iu-container>
    </div>
</template>

<script>
import Nav from './components/Nav';

export default {
    name: 'App',
    components: {
        'iu-nav': Nav,
    },
    data: () => {
        return {
            // searchText: '',
        };
    },
};
</script>

<style lang="scss">
#app {
    font-family: 'Inter', 'Nanum Gothic', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
.main {
    height: calc(100vh - 60px);
}

.iu-header {
    z-index: 100;
}
</style>
